import { html } from "lit";
import { customElement, query } from "lit/decorators.js";
import { ColorTypes } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import rp, { BaseSidebar, Browser, BrowserEvent, BrowserState } from "@reporting/rp-app-host";
import { style } from "./sidebar.style";
import { JobBrowserAdapter } from "../adapters";
import { AccountingRights } from "@reporting/rp-types/core";
import { JobsApplication } from "..";

@customElement('rp-jobs-sidebar')
export class Sidebar extends BaseSidebar<JobsApplication> {

	static styles = [...BaseSidebar.styles, style];

	@query('rp-browser')
	browser: Browser;


	private _browserAdapter: JobBrowserAdapter;
    get browserAdapter() {
        if (!this._browserAdapter) {
            this._browserAdapter = new JobBrowserAdapter();
        }
        return this._browserAdapter;
    }

	firstUpdated() {
		this.browser.addEventListener('browser.state', this._onChangeState);
		this.browser.state = this.state?.jobBrowser as BrowserState;
	}

	getState() {
		return {
			name: 'sidebar',
			jobBrowser: this.browser?.getState(),
		}
	}

	_onChangeState = () => {
		this.dispatchStateEvent();
	}

	refresh = () => {
		this.browser.refresh();
	}

	toggleCollapse = () => {
		this.browser.tree.toggleTreeCollapse();
	};

	_onNewJobSelect = () => {
		rp.host.openModalSidebar({ id: 'jobs-jobForm', caption: msg('New job') });
	}

	_onJobPlansClick = () => {
		rp.host.open(`jobs-jobPlans`, { title: msg('Plans') });
	}

	_onAgentPlansClick = () => {
		rp.host.open(`jobs-agentPlans`, { title: msg('Agent plans') });
	}

	_onSelect = (e: BrowserEvent) => {
		if (e.node.level > 0) rp.host.open(e.node.key, {title: e.node.value});
	}

	render = () => html`
		<div class="controls">

			<og-button
				icon="arrows-rotate"
				title="${msg('Refresh')}"
				color="${ColorTypes.Transparent}"
				@click="${() => this.refresh()}">
			</og-button>

			<og-button
				icon="square-plus"
				title="${msg('Collapse/Expand tree')}"
				color="${ColorTypes.Transparent}"
				@click="${() => this.toggleCollapse()}">
			</og-button>

			${rp.userProvider.hasRight(AccountingRights.JobsDefine) ? html`
				<og-button
					icon="plus"
					title="${msg('New job')}"
					color="${ColorTypes.Transparent}"
					@click="${() => this._onNewJobSelect()}">
				</og-button>

				<og-button
					icon="bars-staggered"
					text="${msg('Plans')}"
					style="min-width: 60px;"
					color="${ColorTypes.Transparent}"
					@click="${() => this._onJobPlansClick()}">
				</og-button>
			` : ''}

			<og-button
				icon="upload"
				text="${msg('Agent')}"
				style="min-width: 60px;"
				color="${ColorTypes.Transparent}"
				@click="${() => this._onAgentPlansClick()}">
			</og-button>
		</div>

		<div class="body">
			<rp-browser id="browser" .adapter="${this.browserAdapter}" @browser.select="${this._onSelect}"></rp-browser>
		</div>
	`;

}
